import { useQuery } from "react-query";
import { ExtractFnReturnType, PossiblyNullishProp } from "types/react-query";
import { fetchEnsAvatar, fetchEnsName } from "wagmi/actions";

type FetchEnsNameParams = Parameters<typeof fetchEnsName>[0];
export const useFetchEnsName = (args: PossiblyNullishProp<FetchEnsNameParams>) => {
  return useQuery<ExtractFnReturnType<typeof fetchEnsName>>(["fetchEnsName", args], {
    enabled: !!args.address,
    queryFn: ({ queryKey }) => fetchEnsName({ ...(queryKey[1] as FetchEnsNameParams) }),
  });
};

type FetchEnsAvatarParams = Parameters<typeof fetchEnsAvatar>[0];
export const useFetchEnsAvatar = (args: PossiblyNullishProp<FetchEnsAvatarParams>) => {
  return useQuery<ExtractFnReturnType<typeof fetchEnsAvatar>>(["fetchEnsAvatar", args], {
    enabled: !!args.name,
    queryFn: ({ queryKey }) => fetchEnsAvatar({ ...(queryKey[1] as FetchEnsAvatarParams) }),
  });
};
